import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ToolTip.scss';
var ToolTip = function ToolTip(_ref) {
  var children = _ref.children,
    tooltipContent = _ref.tooltipContent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var open = function open() {
    return setIsOpen(true);
  };
  var close = function close() {
    return setIsOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative",
    onMouseEnter: open // Handlers are on the parent, rather than button, to make tooltip text selectable after hovering
    ,
    onMouseLeave: close,
    onFocus: open,
    onBlur: close
  }, /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer"
  }, children), /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    className: classNames('z-modal absolute top-0 tooltip', isOpen ? '' : 'hidden'),
    "aria-hidden": !isOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white max-h-300px overflow-y-auto p-4 border border-dark-blue border-solid rounded"
  }, tooltipContent), /*#__PURE__*/React.createElement("div", {
    className: "relative -ml-15px -mt-1px tooltip-arrow"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "30",
    height: "20",
    viewBox: "0 0 30 20"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: 'rgb(24,42,68)',
      strokeWidth: 1,
      fill: 'rgb(255,255,255)'
    },
    points: "0,-1 30,-1 15,20"
  })))));
};
ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipContent: PropTypes.node.isRequired
};
export default ToolTip;
//# sourceMappingURL=ToolTip.js.map